import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var honor = new Swiper(".section1 .swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: '2.42%',
    observer: true,
    observeParents: true,
    resizeObserver: true,
    loop:true,
    speed:1000,//匀速时间
    autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '2.42%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    },
    pagination: {
        el: ".section1 .swiper-pagination",
    },
});